<div
  class="flex gap-3 text-sm rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] bg-surface-magic dark:bg-surface-magic-darkmode border border-1 border-outline dark:border-outline-darkmode p-4"
  data-track="cockpit-location-card"
  [attr.data-location-id]="location().id"
>
  <div
    class="flex-none w-1 rounded-full"
    [style.background-color]="
      location().data?.name + (location().data?.address | address) | randomColor
    "
  ></div>
  <div class="flex-1 flex flex-col sm:grid sm:grid-cols-2 gap-1 sm:gap-5">
    <div class="flex flex-col gap-1 justify-center">
      @if (location().data?.name) {
        <h2
          class="leading-5 line-clamp-1 font-semibold text-on-surface dark:text-on-surface-darkmode"
        >
          {{ location().data?.name }}
        </h2>
        <span
          class="leading-5 line-clamp-1 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
        >
          {{ location().data?.address | address }}
        </span>
      } @else {
        <h2
          class="leading-5 line-clamp-1 font-semibold text-on-surface dark:text-on-surface-darkmode"
        >
          {{ location().data?.address | address }}
        </h2>
      }
    </div>
    <ng-content select="[slot=description]" />
  </div>
  <div class="flex-none">
    <ng-content select="[slot=end]" />
  </div>
</div>
